import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import Badge from '@atlaskit/badge';
import StarIconFilled from '@atlaskit/icon/glyph/star-filled';
import { LinkUtils } from '@atlassian/mpac-utils';
import React, { Component } from 'react';
import { shortFormat } from "../utils/Numeral";
import { FILL_MAP, GREY_STAR, HALF_STAR, HALF_STAR_GRADIENT_HOVER_ID, HALF_STAR_GRADIENT_ID, YELLOW_STAR } from "./Ratings.constants";
import { AverageRating, HalfStarGradientContainer, RatingContainer, RatingsCount, StarIconContainer } from "./Ratings.styles";
import { getStarCounts } from "./Ratings.utils";

var HalfStarGradient = function HalfStarGradient(props) {
  return /*#__PURE__*/React.createElement(HalfStarGradientContainer, null, /*#__PURE__*/React.createElement("linearGradient", {
    id: props.id
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: props.primaryColor
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: props.secondaryColor
  })));
};

var Ratings = /*#__PURE__*/function (_Component) {
  _inherits(Ratings, _Component);

  var _super = _createSuper(Ratings);

  function Ratings() {
    var _this;

    _classCallCheck(this, Ratings);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getStarVariations", function () {
      var averageStars = _this.props.ratings.avgStars;

      var _getStarCounts = getStarCounts(averageStars),
          yellowStarsCount = _getStarCounts.yellowStarsCount,
          halfStarsCount = _getStarCounts.halfStarsCount,
          greyStarsCount = _getStarCounts.greyStarsCount;

      return [].concat(_toConsumableArray(new Array(yellowStarsCount).fill(YELLOW_STAR)), _toConsumableArray(new Array(halfStarsCount).fill(HALF_STAR)), _toConsumableArray(new Array(greyStarsCount).fill(GREY_STAR)));
    });

    _defineProperty(_assertThisInitialized(_this), "getStars", function (clickable) {
      return _this.getStarVariations().map(function (variation, index) {
        return /*#__PURE__*/React.createElement(StarIconContainer, {
          key: index,
          clickable: clickable,
          variation: variation
        }, /*#__PURE__*/React.createElement(StarIconFilled, null));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRatingsClick", function (e) {
      var onClick = _this.props.onClick;

      if (onClick) {
        LinkUtils.maybeOpenInNewTab(e, function () {
          e.stopPropagation();
          onClick();
        });
      }
    });

    return _this;
  }

  _createClass(Ratings, [{
    key: "render",
    value: function render() {
      var numRatings = this.props.ratings.numRatings;
      var clickable = !!this.props.onClick;
      var stars = this.getStars(clickable);
      return /*#__PURE__*/React.createElement(RatingContainer, {
        onClick: this.onRatingsClick,
        clickable: clickable
      }, /*#__PURE__*/React.createElement(HalfStarGradient, {
        id: HALF_STAR_GRADIENT_ID,
        primaryColor: FILL_MAP[YELLOW_STAR].fill,
        secondaryColor: FILL_MAP[GREY_STAR].fill
      }), /*#__PURE__*/React.createElement(HalfStarGradient, {
        id: HALF_STAR_GRADIENT_HOVER_ID,
        primaryColor: FILL_MAP[YELLOW_STAR].fillHover,
        secondaryColor: FILL_MAP[GREY_STAR].fillHover
      }), /*#__PURE__*/React.createElement(AverageRating, null, stars), numRatings && this.props.showRatingCount ? /*#__PURE__*/React.createElement(RatingsCount, null, /*#__PURE__*/React.createElement(Badge, null, "".concat(shortFormat(numRatings)))) : null);
    }
  }]);

  return Ratings;
}(Component);

_defineProperty(Ratings, "defaultProps", {
  showRatingCount: true
});

export { Ratings as default };